export default "__VITE_ASSET__CbnYfr5o__"